import React from 'react'
import { useDispatch } from 'react-redux'
import { set_active_profile } from '../../../redux/slices/influencerProfileSlice'
import { AGENCY_INFLUENCER_STORAGE_KEY } from '../../../constants'
import { PiUserSwitch } from 'react-icons/pi'
import { FaBuildingUser } from 'react-icons/fa6'
import { FormattedMessage } from 'react-intl'
import { useNavigate } from 'react-router-dom'

const HeaderInfluencerProfile = ({ active_profile }) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const handleBackToAgency = () => {
    dispatch(set_active_profile(null))
    localStorage.removeItem(AGENCY_INFLUENCER_STORAGE_KEY)
  }
  return (
    <div className='flex items-center'>
      <div
      onClick={() => { navigate("/profile")}}
        className={`hidden sm:flex cursor-pointer hover:translate-y-[-4px] hover:shadow-lg transition-all items-center justify-center shadow-md border-2 border-primary relative ml-[-10px] bg-cover bg-no-repeat bg-center w-[35px] h-[35px] bg-white border-2 border-primary rounded-full`}
        style={{
          backgroundImage: `url(${active_profile?.user?.picture})`
        }}
      >
        {
          !active_profile?.user?.picture &&
          <p className='text-sm font-semibold text-primary uppercase'>
          {active_profile?.user.name ? active_profile?.user?.name[0] : ""}{active_profile?.user.sur_name ? active_profile?.user?.sur_name[0] : ""}
        </p>
        }
      </div>
      <div className='hidden sm:block h-[2px] w-[35px] bg-primary'>

      </div>

      <div
        onClick={handleBackToAgency}
        className={`cursor-pointer hover:translate-y-[-4px] hover:shadow-lg transition-all flex items-center justify-center shadow-md border-2 border-primary relative bg-cover bg-no-repeat bg-center py-2 px-4  bg-white border-2 border-primary rounded-full`}
      >
        <p className='hidden sm:block text-[10px] font-semibold text-primary'>
          <FormattedMessage id="back_to_agency" defaultMessage={"Back to Agency"} />
        </p>
        {/* <PiUserSwitch className='sm:hidden text-2xl text-primary' /> */}
        <FaBuildingUser className='sm:hidden text-2xl text-primary' />

      </div>
    </div>
  )
}

export default HeaderInfluencerProfile